/**
 * Project Dashboard API
 * Centralised axios calls for the Project Dashboard view.
 * Reuses the same /project-management base path since these
 * operate on the same Project + ProjectTask collections.
 */

import axios from 'axios';

const BASE = '/project-management';

// ── Projects ──────────────────────────────────────────────────────────────────

export const fetchProjects = (params = {}) =>
    axios.get(`${BASE}/projects`, { params });

export const fetchProjectById = (id) =>
    axios.get(`${BASE}/projects/${id}`);

export const createProject = (data) =>
    axios.post(`${BASE}/projects`, data);

export const updateProject = (id, data) =>
    axios.put(`${BASE}/projects/${id}`, data);

export const deleteProject = (id) =>
    axios.delete(`${BASE}/projects/${id}`);

// ── Dashboard Stats ───────────────────────────────────────────────────────────
// Aggregated KPI data: total counts, client/in-house breakdown, status distribution

export const fetchProjectDashboardStats = () =>
    axios.get(`${BASE}/projects/dashboard-stats`);

// ── Tasks (for progress calc) ─────────────────────────────────────────────────
// We fetch all tasks to compute per-project progress on the frontend

export const fetchAllTasks = (params = {}) =>
    axios.get(`${BASE}/tasks`, { params: { ...params, limit: 'all' } });

// ── Employees (for owner/collaborator display) ────────────────────────────────

export const fetchEmployeeNames = () =>
    axios.get('/employeesNames');

// ── CRE Pending Requests ──────────────────────────────────────────────────────
export const fetchPendingProjectRequests = () =>
    axios.get('/cre/projects/pending');
